import React from "react";
import Image from "next/image";
import { GoDotFill } from "react-icons/go";
import MotionSection from "components/section/MotionSection";
import politic from "public/politic.svg";
import social from "public/social.svg";
import economic from "public/economic.svg";
import prophetic from "public/prophetic.svg";
import finance from "public/finance.svg";
import sport from "public/sport.svg";

import PredictionsCarousel from "components/carousel/PredictionsCarousel";
import PredictorsCarousel from "components/carousel/PredictorsCarousel";
import { getMainContent } from "api/main.api";

const categories = [
  { title: "Քաղաքական", icon: politic },
  { title: "Սոցիալական", icon: social },
  { title: "Տնտեսական", icon: economic },
  { title: "Մարգարեական", icon: prophetic },
  { title: "Ֆինանսական", icon: finance },
  { title: "Սպորտային", icon: sport },
];

const info1 = [
  {
    title: "Կանխատեսումները չեն մնում խոսքի մակարդակում",
    description:
      "Համակարգը հետևում է դրանց իրականացմանը և փոփոխում հեղինակների  վարկանիշները։",
  },
  {
    title: "Օբյեկտիվ գնահատման մեխանիզմ",
    description:
      "Վարկանիշները ձևավորվում են կանխատեսումների ճշգրտության հիման վրա։",
  },
];

const info2 = [
  {
    title: "Հետևեք ճշգրիտ կանխատեսողներին",
    description:
      "Բացահայտեք սխալվողներին և տեսեք, թե ինչպես են իրադարձությունները ձևավորում վարկանիշները։",
  },
  {
    title: "կողմնացույց ապագայի տեսլականների աշխարհում",
    description: "Վստահեք փաստերին, ոչ թե դատարկ խոստումներին։",
  },
];

const Main = ({ predictions, predictors }) => {
  return (
    <div className="flex flex-col gap-[24px] items-center mx-[20px]">
      <div className="w-[60%] text-center">
        <MotionSection
          animationVariants={{
            hidden: { y: 50, opacity: 0 },
            visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
          }}
        >
          <span
            style={{
              fontFamily: "Noto Sans Armenian",
            }}
            className="text-[20px] font-[500] text-black leading-none"
          >
            Ո՞վ է իրականում տեսնում ապագան, և ով պարզապես ենթադրում։ Prognos-ը
            գնահատում է կանխատեսումների արժանահավատությունը՝ հիմնվելով փաստերի
            վրա։
          </span>
        </MotionSection>
      </div>

      <MotionSection
        animationVariants={{
          hidden: { y: 50, opacity: 0, width: "100%" },
          visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.8 },
            width: "100%",
          },
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(0deg, #EDF1FF 0%, #EDF1FF 100%), #F3F6FF",
          }}
          className="flex flex-col gap-[24px] p-[24px] w-full rounded-[24px]"
        >
          <div className="flex flex-col md:flex-row gap-[24px] w-full">
            {info1.map((i, index) => {
              return (
                <div
                  key={index}
                  style={{ flex: "1 0 0" }}
                  className="flex flex-col gap-[6px] items-start bg-white rounded-[24px] p-[24px]"
                >
                  <div className="flex items-center gap-2">
                    <GoDotFill size={10} color="#03F" />
                    <span className="relative text-[#03F] text-[16px] font-[600]">
                      {i.title}
                    </span>
                  </div>
                  <span className="text-[#212121] text-[14px] ml-4">
                    {i.description}
                  </span>
                </div>
              );
            })}
          </div>
          <div className="flex flex-col md:flex-row gap-[24px] w-full">
            {info2.map((i, index) => {
              return (
                <div
                  key={index}
                  style={{ flex: "1 0 0" }}
                  className="flex flex-col gap-[6px] items-start bg-white rounded-[24px] p-[24px]"
                >
                  <div className="flex items-center gap-2">
                    <GoDotFill size={10} color="#03F" />
                    <span className="relative text-[#03F] text-[16px] font-[600]">
                      {i.title}
                    </span>
                  </div>
                  <span className="text-[#212121] text-[14px] ml-4">
                    {i.description}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </MotionSection>
      <MotionSection
        animationVariants={{
          hidden: { y: 50, opacity: 0 },
          visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
        }}
      >
        <PredictionsCarousel slides={predictions} />
      </MotionSection>
      <div className="bg-[#EDF1FF] p-[24px] rounded-[24px] w-full mb-44">
        <MotionSection
          animationVariants={{
            hidden: { y: 50, opacity: 0 },
            visible: { y: 0, opacity: 1, transition: { duration: 0.8 } },
          }}
        >
          <div className="mb-[24px] w-full">
            <span className="text-[34px] text-[#141414]">Կանխատեսողներ</span>
            <div className="flex justify-between flex-wrap gap-[24px] mt-[14px]">
              {categories.map((category) => {
                return (
                  <div
                    key={category.title}
                    className="flex items-center gap-[10px] rounded-[14px] p-[16px] bg-white"
                  >
                    <Image
                      width={26}
                      height={26}
                      src={category.icon}
                      alt="person"
                      priority
                      className=""
                    />
                    <span className="text-[14px]">{category.title}</span>
                  </div>
                );
              })}
            </div>
          </div>
          <PredictorsCarousel slides={predictors} />
        </MotionSection>
      </div>
    </div>
  );
};

export async function getServerSideProps() {
  const mainContent = await getMainContent();
  const formatData = (data) => {
    return data.reduce((acc, category) => {
      acc[category.id] = category.content;
      return acc;
    }, {});
  };
  const { predictions, predictors } = formatData(mainContent);
  return {
    props: {
      predictions,
      predictors,
    },
  };
}

export default Main;
